import { get, last, nth, omit } from 'lodash-es';
import {
  TOGGLE_QUICKVIEW,
  HISTORY_PREV_ITEM,
  SAVE_SCROLL_POSITION,
  SET_ADDITIONAL_PARAMS,

  APP_QUICKVIEW_REQUEST,
  APP_QUICKVIEW_SUCCESS,
  APP_QUICKVIEW_FAILURE,

  DETAILS_APP_QUICKVIEW_REQUEST,
  DETAILS_APP_QUICKVIEW_SUCCESS,
  DETAILS_APP_QUICKVIEW_FAILURE,

  PUB_QUICKVIEW_REQUEST,
  PUB_QUICKVIEW_SUCCESS,
  PUB_QUICKVIEW_FAILURE,
  PUB_QUICKVIEW_SALESFORCE_UPDATE,

  COMPANY_QUICKVIEW_REQUEST,
  COMPANY_QUICKVIEW_SUCCESS,
  COMPANY_QUICKVIEW_FAILURE,

  CANCEL_REQUEST,
} from '../actions/action-types';

export default (state, action) => {
  switch (action.type) {
    case TOGGLE_QUICKVIEW:
      return {
        ...state,
        isOpen: action.isOpen,
        activeEntity: action.activeEntity || {},
        history: action.isOpen ? [...state.history, action.activeEntity] : [],
      };

    case HISTORY_PREV_ITEM:
      return {
        ...state,
        activeEntity: nth(state.history, -2),
        history: state.history.slice(0, -1),
      };

    case SAVE_SCROLL_POSITION:
      return {
        ...state,
        history: state.history.slice(0, -1).concat({
          ...last(state.history),
          scrollPosition: action.scrollPosition,
        }),
      };

    case SET_ADDITIONAL_PARAMS:
      return {
        ...state,
        additionalParams: action.additionalParams,
      };

    case APP_QUICKVIEW_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          aqv: {
            ...state.settings.aqv,
            [action.asset]: { pending: true, error: false },
          },
        },
      };
    case APP_QUICKVIEW_SUCCESS: {
      const uniqKey = Object.keys(action.data)[0];
      const shouldMergeData = !action.byAssetFetch
        || (action.byAssetFetch && !!state.data[uniqKey]);

      return {
        ...state,
        ...(shouldMergeData ? {
          data: {
            ...state.data,
            [uniqKey]: {
              ...state.data[uniqKey],
              ...action.data[uniqKey],
            },
          },
        } : {}),
        settings: {
          ...state.settings,
          aqv: {
            ...state.settings.aqv,
            [action.asset]: { pending: false, error: false },
          },
        },
      };
    }
    case APP_QUICKVIEW_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          aqv: {
            ...state.settings.aqv,
            [action.asset]: { pending: false, error: true },
          },
        },
      };

    case DETAILS_APP_QUICKVIEW_REQUEST:
      return {
        ...state,
        settings: { ...state.settings,
          aqvDetails: {
            ...state.settings.aqvDetails,
            pending: true,
            error: false,
          } },
      };
    case DETAILS_APP_QUICKVIEW_SUCCESS: {
      const uniqKey = Object.keys(action.data)[0];

      return {
        ...state,
        data: {
          ...state.data,
          [uniqKey]: {
            ...state.data[uniqKey],
            app_details: {
              ...get(state.data, [uniqKey, 'app_details'], {}),
              ...action.data[uniqKey].app_details,
            },
          },
        },
        settings: {
          ...state.settings,
          aqvDetails: {
            ...state.settings.aqvDetails,
            pending: false,
          },
        },
      };
    }
    case DETAILS_APP_QUICKVIEW_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          aqvDetails: {
            ...state.settings.aqvDetails,
            pending: false,
            error: true,
          },
        },
      };

    case PUB_QUICKVIEW_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          pqv: {
            ...state.settings.pqv,
            [action.asset]: { pending: true, error: false },
          },
        },
      };
    case PUB_QUICKVIEW_SUCCESS: {
      const uniqKey = Object.keys(action.data)[0];

      return {
        ...state,
        data: {
          ...state.data,
          [uniqKey]: {
            ...state.data[uniqKey],
            ...action.data[uniqKey],
          },
        },
        settings: {
          ...state.settings,
          pqv: {
            ...state.settings.pqv,
            [action.asset]: { pending: false, error: false },
          },
        },
      };
    }
    case PUB_QUICKVIEW_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          pqv: {
            ...state.settings.pqv,
            [action.asset]: { pending: false, error: true },
          },
        },
      };

    case PUB_QUICKVIEW_SALESFORCE_UPDATE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.uniqKey]: {
            ...state.data[action.uniqKey],
            publisher: {
              ...state.data[action.uniqKey].publisher,
              salesforce_account_url: action.salesforce_account_url,
            },
          },
        },
      };

    case COMPANY_QUICKVIEW_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          cqv: {
            ...state.settings.cqv,
            [action.asset]: { pending: true, error: false },
          },
        },
      };
    case COMPANY_QUICKVIEW_SUCCESS: {
      const uniqKey = Object.keys(action.data)[0];

      return {
        ...state,
        data: {
          ...state.data,
          [uniqKey]: {
            ...state.data[uniqKey],
            ...action.data[uniqKey],
          },
        },
        settings: {
          ...state.settings,
          cqv: {
            ...state.settings.cqv,
            [action.asset]: { pending: false, error: false },
          },
        },
      };
    }
    case COMPANY_QUICKVIEW_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          cqv: {
            ...state.settings.cqv,
            [action.asset]: { pending: false, error: true },
          },
        },
      };

    case CANCEL_REQUEST:
      return {
        ...state,
        data: omit(state.data, action.uniqKey),
        history: state.history.filter(item => item.uniqKey !== action.uniqKey),
      };
    default:
      return state;
  }
};
